import type { Project } from '@/types/project';
import { SCHEMA_VERSION } from '@/lib/constants';
import { db } from './codexDB';

/**
 * 데이터 레벨 마이그레이션 (Dexie 스토어 스키마 마이그레이션과는 별개).
 * Project.schemaVersion 과 연동, 앱 부팅 시 점검. v1 = no-op.
 */
export async function runDataMigrations(project: Project): Promise<Project> {
  let p = project;
  if (p.schemaVersion < SCHEMA_VERSION) {
    // 예시(미래):
    // if (p.schemaVersion < 2) { await db.entities.toCollection().modify(e => { ... }); }
    p = { ...p, schemaVersion: SCHEMA_VERSION, updatedAt: Date.now() };
    await db.project.put(p);
  }
  return p;
}
